import NotFound from "@/src/components/not-found";
import NotFoundSearch from "@/src/components/not-found-search";
import NotFoundSuggestion from "@/src/components/not-found-suggestion";

const NotFoundScreen = () => {
  return (
    <>
      <div id="content-wrapper">
        <NotFound />
        <NotFoundSearch />
        <NotFoundSuggestion />
      </div>
    </>
  );
};

export default NotFoundScreen;
